import { PaginationDto } from '@/models/dtos/paginationDto'

export class PaginationHelper {
  static readonly CURRENT_PAGE = 1;
  static readonly PAGE_SIZE = 15;

  static getModel(currentPage?: number, pageSize?: number): PaginationDto {
    const model: PaginationDto = {
      pageNumber: currentPage || this.CURRENT_PAGE,
      pageSize: pageSize || this.PAGE_SIZE
    }

    return model
  }
}
